import { combineReducers } from 'redux';
import {reducer as formReducer} from 'redux-form'
import GoogleMapsReducer from './GoogleMaps/googleMapsReducer'


const rootReducer = combineReducers({
   form: formReducer,
   GoogleMapsReducer
});

export default rootReducer;


// WEBPACK FOOTER //
// ./src/reducers/index.js